import React from "react";
import { useAccount } from "wagmi";

import Navbar from "../components/Navbar";
import RecoveryExecutionForm from "../components/RecoveryExecutionForm";
import { writeContract, createConfig } from "@wagmi/core";
import {
  SOCIAL_RECOVERY_MODULE_ABI,
  SOCIAL_RECOVERY_MODULE_ADDRESS,
} from "../utils/Constants";

import "./RecoverTxPage.css";
import { baseSepolia } from "viem/chains";

function RecoverTxPage() {
  const { address, isConnected } = useAccount();

  return (
    <div className="recover-tx-page">
      <Navbar activePage="recover-tx" />
      <RecoveryExecutionForm />
    </div>
  );
}

export default RecoverTxPage;
